import { FC } from "react";

import { ClassSessionCategory } from "components/server-types";
import { t } from "i18n/i18n";
import { PillButton } from "mds/components/PillButton";
import { useIsMdOrLarger } from "mds/hooks/use-responsive";
import { useAppSelector } from "store/index";
import { selectClassSessionCategoryByCourseId } from "store/selectors";
import { Link } from "utils/routing";
import { courseHomeUrl } from "utils/urls";

export const SessionInProgressButton: FC<{ courseId: string }> = ({ courseId }) => {
  const isSmallScreen = !useIsMdOrLarger();
  const classSessionCategory = useAppSelector((state) =>
    selectClassSessionCategoryByCourseId(state, courseId),
  );

  if (
    !classSessionCategory ||
    (classSessionCategory === ClassSessionCategory.VIRTUAL && isSmallScreen)
  ) {
    return null;
  }

  return (
    <PillButton
      as={Link}
      eventName="Join Session"
      kind="blue"
      size="xs"
      to={courseHomeUrl(courseId)}
    >
      {t("home.session_in_progress")}
    </PillButton>
  );
};
